import { useState, useEffect } from 'react';

export type UserFilterType = 'all' | 'withOrganization' | 'withoutOrganization';

export interface UserFiltersState {
  searchTerm: string;
  filterType: UserFilterType;
}

export function useAdminUserFilters(users: any[]) {
  const [filters, setFilters] = useState<UserFiltersState>({
    searchTerm: '',
    filterType: 'all',
  });
  const [filteredUsers, setFilteredUsers] = useState<any[]>(users || []);

  // Update search term
  const updateSearchTerm = (term: string) => {
    setFilters((prev) => ({ ...prev, searchTerm: term }));
  };

  // Update filter type
  const updateFilterType = (type: UserFilterType) => {
    setFilters((prev) => ({ ...prev, filterType: type }));
  };

  // Apply filters whenever filters or users change
  useEffect(() => {
    if (!users || users.length === 0) {
      setFilteredUsers([]);
      return;
    }

    // First apply organization filter
    let result = [...users];

    if (filters.filterType === 'withOrganization') {
      result = result.filter((user) => {
        return user.organisatie && user.organisatie.trim() !== '';
      });
    } else if (filters.filterType === 'withoutOrganization') {
      result = result.filter((user) => {
        return !user.organisatie || user.organisatie.trim() === '';
      });
    }

    // Then apply search term filter if there is one
    if (filters.searchTerm.trim() !== '') {
      const lowercaseValue = filters.searchTerm.toLowerCase();
      result = result.filter(
        (user) =>
          (user.email && user.email.toLowerCase().includes(lowercaseValue)) ||
          (user.naam && user.naam.toLowerCase().includes(lowercaseValue)) ||
          (user.organisatie &&
            user.organisatie.toLowerCase().includes(lowercaseValue)) ||
          (user.team && user.team.toLowerCase().includes(lowercaseValue)) ||
          (user.telefoonnummer &&
            user.telefoonnummer.toLowerCase().includes(lowercaseValue)),
      );
    }

    setFilteredUsers(result);
  }, [filters, users]);

  return {
    filters,
    filteredUsers,
    setFilteredUsers,
    updateSearchTerm,
    updateFilterType,
  };
}
